import { apiRequest } from "./apiClient";

function searchQuery(options = {}) {
  const params = new URLSearchParams();
  params.set("bankAccountId", options.bankAccountId);
  params.set("page", Math.max(0, Number(options.page) || 0));
  params.set("size", Math.min(100, Math.max(1, Number(options.size) || 20)));
  ["status", "type", "from", "through", "actorId", "query"].forEach((key) => {
    if (options[key] !== undefined && options[key] !== null && options[key] !== "") {
      params.set(key, options[key]);
    }
  });
  return params.toString();
}

export function listTransactions(options) {
  return apiRequest(`/api/transactions?${searchQuery(options)}`);
}

export function getAccountBalance(bankAccountId) {
  return apiRequest(`/api/transactions/balance?bankAccountId=${encodeURIComponent(bankAccountId)}`);
}

export function createTransaction(values) {
  return apiRequest("/api/transactions", { method: "POST", body: JSON.stringify(values) });
}

export function updateTransaction(id, values) {
  return apiRequest(`/api/transactions/${id}`, { method: "PUT", body: JSON.stringify(values) });
}

export function voidTransaction(id, reason) {
  return apiRequest(`/api/transactions/${id}?reason=${encodeURIComponent(reason)}`, { method: "DELETE" });
}

export function createInternalTransfer(values) {
  return apiRequest("/api/transactions/internal-transfer", {
    method: "POST",
    body: JSON.stringify(values),
  });
}
